var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6788 22.1802L10.6788 22.1802L10.6843 22.185C11.4404 22.8417 12.5696 22.8417 13.3257 22.185L13.3257 22.1851L13.332 22.1795C15.8112 19.9899 17.7137 17.9104 19.0022 15.9382C20.2892 13.9682 21 12.0486 21 10.2C21 4.63711 16.7212 1 12 1C7.27882 1 3 4.63711 3 10.2C3 12.0487 3.71085 13.9683 4.99933 15.9386C6.2892 17.9109 8.19438 19.9905 10.6788 22.1802ZM12 11C11.4523 11 11 10.5477 11 10C11 9.45228 11.4523 9 12 9C12.5477 9 13 9.45228 13 10C13 10.5477 12.5477 11 12 11Z",
    fill: "#0C55B8",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderLocation);
export default __webpack_public_path__ + "static/media/provider_location.6c7b7444367ccb87562a98e042c9111c.svg";
export { ForwardRef as ReactComponent };